/**
 * leadAssignees — single source of truth for "who can be assigned a CRM lead".
 *
 * Separates the *display* policy from the *permissions* policy. Being an
 * assignable owner does NOT grant any additional access to the CRM; it just
 * means the user can appear in the "Asignado a" selector and the owner
 * filter.
 *
 * Hybrid policy:
 *   - admin / marketing → automatically assignable (any new hire surfaces
 *     without code changes).
 *   - investor → only the explicit allow-list below (Diego, Víctor) so
 *     unrelated client-investors don't pollute the dropdown.
 *   - constructor → never assignable in the CRM.
 */

export const ASSIGNABLE_ROLES = ["admin", "marketing", "investor"];

// Investor users that wear a commercial hat in addition to investing.
// Edit by email (lowercase) — names can change but emails are stable.
const ALLOWED_INVESTOR_ASSIGNEE_EMAILS = new Set([
  "ejasguirri@gmail.com",
  "victor_mayoral@hotmail.com",
]);

function normalizeEmail(e) {
  return String(e || "").trim().toLowerCase();
}

/** True when the user can be assigned as the owner of a lead. */
export function isAssignableUser(u) {
  if (!u) return false;
  if (u.is_active === false) return false;
  if (!u.name && !u.email) return false;
  if (u.role === "admin" || u.role === "marketing") return true;
  if (u.role === "investor") {
    return ALLOWED_INVESTOR_ASSIGNEE_EMAILS.has(normalizeEmail(u.email));
  }
  return false;
}

/** Filter helper for arrays returned by GET /users. */
export function filterAssignableUsers(users) {
  return (users || []).filter(isAssignableUser);
}
